export enum ELinkRel {
    UNDEFINED = '',
    NOFOLLOW = 'nofollow',
    NOREFERRER = 'noreferrer',
    NOOPENER = 'noopener',
    NEXT = 'next',
    PREV = 'prev',
    EXTERNAL = 'external',
}

export enum ELinkTarget {
    BLANK = '_blank',
    SELF = '_self',
}
